import $ from 'jquery';
window.$ = window.jQuery = $;

require('./bootstrap');

$(document).ready(function () {
    if (typeof window['lightbox'] !== 'undefined') {
        lightbox.option({
            'albumLabel': "Снимка %1 от %2"
        });
    }

    $('.gallery-btn').on('click', function () {
        let typeId = $(this).attr('data-type');

        $('.gallery-btn').removeClass('active');
        $(this).addClass('active');

        $.ajax({
            url: `/galeriya`,
            method: 'GET',
            data: {
                type: typeId
            },
            success: function(response) {
                let gallery = $('.images-content');
                gallery.empty()

                response.forEach(function(el, index) {
                    let template = `
                        <div class="col-lg-3 col-md-6 col-12">
                            <div class="student-card mb-4">
                                <div class="avatar-wrapper">
                                    <div class="student-avatar">
                                        <a href="${el.filename}" data-lightbox="gallery">
                                            <img src="${el.filename}" loading="lazy" alt="Снимка ${index}">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>`;

                    gallery.append(template);
                });
            },
            error: function (error) {
                console.log(error);
            },
        })
    });

    $('.page-code-challenge').each(function(i, page) {
        $(page).find('.collapse').each(function(index, item) {
            $(item).on('show.bs.collapse', function() {
                var id = $(this).first().attr('id');
                var $button = $(page).find('button[data-bs-target=\\#' + id + ']:last').closest('.months').parent().find('> button');

                $button.closest('.section-actions').find('button:not(.collapsed)').addClass('collapsed');
                setTimeout(function() {
                    $button.removeClass('collapsed');
                });
            }).on('hidden.bs.collapse', function() {
                var $collapse = $(this);
                setTimeout(function() {
                    !$collapse.parent().find('.collapse.show').length && $collapse.collapse('show');
                }, 100);
            });
        });
    });

    $('.page-white-label').each(function(i, v) {

        $(v).find('.why-us').each(function(i, v) {
            var count = $('.fade-in, .slide-in').length;
            var $wrapper = $(v);
            var current = 0;
            var appearOnScroll = new IntersectionObserver(
                function (entries, appearOnScroll) {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) {
                            return;
                        } else {
                            $(entry.target).addClass('appear');
                            appearOnScroll.unobserve(entry.target);
                            if (++current >= count) {
                                $wrapper.removeClass('overflow-hidden');
                            }
                        }
                    })
                },
                {
                    threshold: 0,
                    rootMargin: "0px 0px -250px 0px"
                }
            );

            $(".fade-in").each((i, fader) => appearOnScroll.observe(fader));
            $(".slide-in").each((i, slider) => appearOnScroll.observe(slider));
            $wrapper.addClass('overflow-hidden');
        });
    });

    $("#subscribeEmail, #unsubscribeEmail").each(function(e) {
        var $wrap = $(this);
        var $email = $wrap.find("input[type=text]");
        var $btn = $wrap.find("input[type=submit]");
        var $form = $wrap.find('form');
        var timeout = null;
        var shownEmailSubscription = false;
        var showEmailSubscription = function() {
            timeout && clearTimeout(timeout);

            if (shownEmailSubscription) {
                return;
            }

            timeout = setTimeout(function() {
                $("#subscribeEmail").modal('show');
                shownEmailSubscription = true;
            }, 15000);
        }

        if (!document.hidden) {
            showEmailSubscription();
        }
        $(window).on('focus', showEmailSubscription);
        $(window).on('blur', function() {
            timeout && clearTimeout(timeout);
        });

        $("#unsubscribeEmail").modal('show');

        $email.on('input', function(e) {
            $btn.attr('disabled', !$(this).val().length)
        });

        $form.on('submit', function(e) {
            e.preventDefault();

            formAlertsReset($wrap);

            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                contentType: "application/json",
                dataType: "json",
                data: getFormData($form),
                success: function(response) {
                    formAlertsSuccess($wrap, response || {});
                    $email.val('').trigger('input');
                },
                error: function (error) {
                    formAlertsErrors($wrap, error.responseJSON || {});
                }
            });

            return false;
        });
    });


    (function() {
        var cookieName = 'usergdrp';
        var userAccept = getCookie(cookieName);
        var $cookieContainer = $('#cookie-condition');
        var $cookieAcceptBtn = $cookieContainer.find('.cookie-btn-success');

        if (!userAccept) {
            $cookieContainer.css("display", "block");
            $cookieAcceptBtn.on('click', function( e ) {
                e.preventDefault();

                setCookie(cookieName, 'true', 365);

                if (!!getCookie(cookieName)) {
                    $cookieContainer.css("display", "none");
                }
            })
        }
    })();

    function getCookie(name) {
        var value = `; ${document.cookie}`;
        var parts = value.split(`; ${name}=`);

        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    function setCookie(name, val, exdays) {
        const time = new Date();
        time.setTime(time.getTime() + (exdays * 24 * 60 * 60 *1000));
        let expires = "expires=" + time.toUTCString();
        document.cookie = name + "=" + val + ";" + expires + ";path=/";
    }

    function getFormData($form) {
        var serializeArray = $form.serializeArray();
        var indexedArray = {};

        $.map(serializeArray, function(n, i){
            indexedArray[n['name']] = n['value'];
        });

        return JSON.stringify(indexedArray);
    }

    function formAlertsReset($wrap) {
        $wrap.find('.alert').removeClass('alert-danger alert-success d-block').addClass('d-none').find('.text').html('');
        $wrap.find('.form-control.is-invalid').removeClass('is-invalid');
        $wrap.find('.invalid-feedback').remove();
    }

    function formAlertsErrors($wrap, response) {
        if ('message' in response) {
            $wrap.find('.alert')
                .addClass('alert-danger')
                .removeClass('d-none')
                .find('.text')
                .text(response.message);
        }

        if ('errors' in response && !$.isEmptyObject(response.errors)) {
            for (var field in response.errors) {
                $wrap.find('input[name=' + field + ']').addClass('is-invalid');

                for (var error of response.errors[field]) {
                    var $item = $("<div/>", {class: 'invalid-feedback', text: error.message || ''})
                    $wrap.find('input[name=' + field + ']').after($item);
                }
            }
        }
    }

    function formAlertsSuccess($wrap, response) {
        response = response || {};

        if ('message' in response) {
            $wrap.find('.alert')
                .addClass('alert-success')
                .removeClass('d-none')
                .find('.text')
                .text(response.message);
        }
    }
});
